// extracted by mini-css-extract-plugin
export default {"NavigationButtons":"hPyMyALtjbRxMi29oe3A","Fixed":"EyVBv0d2WQVlILJP3Vu7"};